import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface FullScreenControlPlainProps {
  onClick: () => void;
  condition: boolean;
}

export const FullScreenControlPlain: FC<FullScreenControlPlainProps> = ({ onClick, condition }) => {
  return (
    <IconButtonWithTooltip
      data-testid="full-screen-button"
      icon={condition ? Icons.FullscreenExit : Icons.FullscreenEnter}
      active={condition}
      onClick={onClick}
      tooltipOptions={{
        text: condition ? 'EXIT_FULLSCREEN' : 'FULLSCREEN',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
